module.exports = __webpack_public_path__ + "media/images/lb/592-f5646621279275c3e0394cacd05c8c20.svg";